import { useQuery } from '@tanstack/react-query'

import { FloridayUser } from 'src/common'
import { useApiClient } from 'src/common/providers'

export default function useFloridayUser(
  userName: string
): FloridayUser | undefined {
  const { apiClient } = useApiClient()

  const floridayUsers = useQuery({
    queryKey: ['floridayUserDisplayName', userName],
    queryFn: () => apiClient.byAlternateId(userName),
    enabled: !!userName,
    keepPreviousData: true,
  })

  return floridayUsers?.data?.[0]
}
